/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Air_Handler_Unit_Coil_ChillerInputs */



/**
* | output |
* | --- |
* | "Chiller coil" |
*
* @param {Air_Handler_Unit_Coil_ChillerInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const air_handler_unit_coil_chiller = /** @type {((inputs?: Air_Handler_Unit_Coil_ChillerInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Air_Handler_Unit_Coil_ChillerInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Chiller coil")
	return /** @type {LocalizedString} */ ("Groupe froid")
});